import React from 'react';
import { observer } from "mobx-react";
import { Form, Input } from 'antd';

@observer
export class ColorVariantSpecific extends React.Component {
    componentDidMount() {
        if (!this.props.variant.typeSpecific.allowedType) {
            this.props.onChange('allowedType', 'Wall');
        }
    }

    render() {
        const { variant, onChange } = this.props;
        return (
            <Form.Item label="Diffuse color">
                <Input
                    size="small"
                    placeholder="RGB"
                    value={variant.typeSpecific.diffuseColor ?? ''}
                    onChange={({ target }) => onChange('diffuseColor', target.value)}
                />
            </Form.Item>
        );
    }
}
